document.querySelectorAll(".js-tabGroup").forEach(group => {
  const tabToggles = group.querySelectorAll(".js-tabToggle");
  const tabContents = group.querySelectorAll(".js-tabContent");

  tabToggles.forEach(tabToggle => {
    tabToggle.addEventListener("click", () => {
      const tabName = tabToggle.dataset.tabName;

      // 同じグループ内のみ処理
      tabToggles.forEach(el => el.classList.remove("is-active"));
      tabContents.forEach(el => el.classList.remove("is-active"));

      tabToggle.classList.add("is-active");

      tabContents.forEach(content => {
        if (content.dataset.tabTarget === tabName) {
          content.classList.add("is-active");
        }
      });
    });
  });
});